// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__JwVAy","rootSmall":"AddTileButton_rootSmall__3C792"};